// Authenticated route — `/billing-locked` (US-200, Wave B6).
//
// Hard-block splash. Mounted at the authed layout level so the user-card
// dropdown stays reachable (logout still works) but the inbox / campaigns
// chrome is hidden via the `_authed/__layout` outlet — the splash itself
// fills the viewport.

import { createRoute } from '@tanstack/react-router';

import { TrialExpiredSplash } from '@/features/billing/TrialExpiredSplash';

import { Route as AuthedLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: '/billing-locked',
  component: TrialExpiredSplash,
});
